const R = Math.PI / 180;
export const fmt = (v, d = 2) => (Math.abs(v - Math.round(v)) < 1e-9 ? String(Math.round(v)) : v.toFixed(d).replace(/\.?0+$/, "")).replace(".", ",");

export function triangle(mode, v) {
  let a, b, c, A, B, C;
  if (mode === "KKK") {
    [a, b, c] = [v.a, v.b, v.c];
    if (!(a > 0 && b > 0 && c > 0) || a + b <= c || a + c <= b || b + c <= a) throw new Error("Üçgen eşitsizliği sağlanmıyor: her kenar diğer ikisinin toplamından küçük olmalı");
    A = Math.acos((b * b + c * c - a * a) / (2 * b * c)) / R; B = Math.acos((a * a + c * c - b * b) / (2 * a * c)) / R; C = 180 - A - B;
  } else if (mode === "KAK") {
    [b, c, A] = [v.b, v.c, v.A];
    if (!(b > 0 && c > 0 && A > 0 && A < 180)) throw new Error("Kenarlar pozitif, açı 0° ile 180° arasında olmalı");
    a = Math.sqrt(b * b + c * c - 2 * b * c * Math.cos(A * R)); B = Math.acos((a * a + c * c - b * b) / (2 * a * c)) / R; C = 180 - A - B;
  } else {
    [A, B, c] = [v.A, v.B, v.c];
    if (!(A > 0 && B > 0 && A + B < 180 && c > 0)) throw new Error("İki açının toplamı 180°'den küçük, kenar pozitif olmalı");
    C = 180 - A - B; a = (c * Math.sin(A * R)) / Math.sin(C * R); b = (c * Math.sin(B * R)) / Math.sin(C * R);
  }
  const pts = [[0, 0], [c, 0], [b * Math.cos(A * R), b * Math.sin(A * R)]];
  const s = (a + b + c) / 2;
  return { pts, sides: [c, a, b], angles: [A, B, C], info: [["Çevre", `${fmt(a + b + c)} birim`], ["Alan", `${fmt(Math.sqrt(s * (s - a) * (s - b) * (s - c)))} birim²`], ["Açılar toplamı", "180°"]] };
}

export function polygon(n, s) {
  if (!(n >= 3 && n <= 12 && s > 0)) throw new Error("Kenar sayısı 3-12, kenar uzunluğu pozitif olmalı");
  const r = s / (2 * Math.sin(Math.PI / n)), off = -Math.PI / 2 - Math.PI / n;
  const pts = Array.from({ length: n }, (_, k) => [r * Math.cos(off + (2 * Math.PI * k) / n), -r * Math.sin(off + (2 * Math.PI * k) / n)]);
  const ia = ((n - 2) * 180) / n;
  return { pts, sides: pts.map(() => s), angles: pts.map(() => ia), info: [["Çevre", `${fmt(n * s)} birim`], ["Alan", `${fmt((n * s * s) / (4 * Math.tan(Math.PI / n)))} birim²`], ["İç açı", `${fmt(ia)}°`], ["İç açılar toplamı", `${(n - 2) * 180}°`]] };
}

const FN = { sin: "Math.sin", cos: "Math.cos", tan: "Math.tan", sqrt: "Math.sqrt", kok: "Math.sqrt", abs: "Math.abs", log: "Math.log10", ln: "Math.log", pi: "Math.PI", π: "Math.PI" };
export function compile(expr) {
  const e = expr.replace(/,/g, ".").replace(/\s+/g, "").replace(/^y=/i, "").toLowerCase();
  if (!e || !/^[0-9x+\-*/^().a-zπ]+$/.test(e)) throw new Error(`Geçersiz ifade: ${expr}`);
  const words = e.match(/[a-zπ]+/g) || [];
  if (words.some((w) => w !== "x" && !FN[w])) throw new Error(`Bilinmeyen fonksiyon: ${expr}`);
  const js = e.replace(/[a-zπ]+/g, (w) => FN[w] || w).replace(/(\d)(x|Math|\()/g, "$1*$2").replace(/\)(x|\d|\(|Math)/g, ")*$1").replace(/x(\d|x|\(|Math)/g, "x*$1").replace(/\^/g, "**");
  const f = new Function("x", `return ${js};`); // eslint-disable-line no-new-func
  f(1);
  return f;
}

export async function svgToFile(svg, name = "geometri.png") {
  const xml = new XMLSerializer().serializeToString(svg), img = new Image(), w = svg.viewBox.baseVal.width, h = svg.viewBox.baseVal.height;
  img.src = URL.createObjectURL(new Blob([xml], { type: "image/svg+xml" }));
  await img.decode();
  const cv = document.createElement("canvas"); cv.width = w * 2; cv.height = h * 2;
  const ctx = cv.getContext("2d"); ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, cv.width, cv.height); ctx.drawImage(img, 0, 0, cv.width, cv.height);
  const blob = await new Promise((r) => cv.toBlob(r, "image/png"));
  return new File([blob], name, { type: "image/png" });
}

export function geoQuiz(tool, fig, o, g) {
  const u = o.unit, V = "ABCDEFGHIJKL";
  if (tool === "triangle") {
    const sn = ["|AB|", "|BC|", "|AC|"], [A, B, C] = fig.angles, s = fig.sides, p = s[0] + s[1] + s[2], h = p / 2, area = Math.sqrt(h * (h - s[0]) * (h - s[1]) * (h - s[2]));
    const targets = [...sn.map((n, k) => ({ key: `s${k}`, label: `${n} uzunluğu`, answer: `${fmt(s[k])} ${u}` })), ...["A", "B", "C"].map((n, k) => ({ key: `a${k}`, label: `m(${n}) açısı`, answer: `${fmt([A, B, C][k], 1)}°` })),
      { key: "area", label: "Alan", answer: `${fmt(area)} ${u}²` }, { key: "per", label: "Çevre", answer: `${fmt(p)} ${u}` }];
    const facts = (hide) => `ABC üçgeni. ${o.sides ? sn.map((n, k) => (hide === `s${k}` ? `${n} = ?` : `${n} = ${fmt(s[k])} ${u}`)).join(", ") : ""}. ${o.angles ? ["A", "B", "C"].map((n, k) => (hide === `a${k}` ? `m(${n}) = ?` : `m(${n}) = ${fmt([A, B, C][k], 1)}°`)).join(", ") : ""}.`;
    return { targets, facts };
  }
  if (tool === "polygon") {
    const n = fig.pts.length, s = fig.sides[0];
    const targets = [{ key: "a0", label: "Bir iç açının ölçüsü", answer: `${fmt(fig.angles[0])}°` }, { key: "ext", label: "Bir dış açının ölçüsü", answer: `${fmt(360 / n)}°` }, { key: "sum", label: "İç açılar toplamı", answer: `${(n - 2) * 180}°` },
      { key: "per", label: "Çevre", answer: `${fmt(n * s)} ${u}` }, { key: "area", label: "Alan", answer: `${fmt((n * s * s) / (4 * Math.tan(Math.PI / n)))} ${u}²` }];
    return { targets, facts: (hide) => `Düzgün ${n}-gen ${V.slice(0, n)}. Bir kenarı ${fmt(s)} ${u}.${o.angles ? (hide === "a0" ? " İç açılar ? ile gösterilmiş." : ` İç açılar ${fmt(fig.angles[0])}°.`) : ""}` };
  }
  if (tool === "circle") {
    const r = fig.r;
    const targets = [{ key: "per", label: "Çevre", answer: `${fmt(2 * r)}π ${u} (π = 3 alınırsa ${fmt(6 * r)} ${u})` }, { key: "area", label: "Alan", answer: `${fmt(r * r)}π ${u}² (π = 3 alınırsa ${fmt(3 * r * r)} ${u}²)` }, { key: "d", label: "Çap", answer: `${fmt(2 * r)} ${u}` }];
    return { targets, facts: () => `Merkezi O olan çember, yarıçap r = ${fmt(r)} ${u}.` };
  }
  if (tool === "angle") {
    const d = fig.deg;
    const targets = [...(d < 90 ? [{ key: "tum", label: "Tümler açısı", answer: `${fmt(90 - d)}°` }] : []), ...(d < 180 ? [{ key: "but", label: "Bütünler açısı", answer: `${fmt(180 - d)}°` }] : []), { key: "type", label: "Açının türü", answer: fig.info[2][1] }];
    return { targets, facts: () => `AOB açısı, m(AOB) = ${fmt(d)}°.` };
  }
  return { targets: [{ key: "free", label: "Grafikten okunabilen bir değer (serbest)", answer: "" }], facts: () => `Koordinat düzleminde ${g.exprs.map((e) => `y = ${e}`).join(", ")} grafikleri${g.points.length ? `, noktalar: ${g.points.map(([n, x, y]) => `${n}(${fmt(x)}; ${fmt(y)})`).join(", ")}` : ""}; x ∈ [${g.xmin}, ${g.xmax}].` };
}
